var toggleDownloadSection = function(event) {
  var button = event.target;
  var downloadContainer = document.querySelector('[data-download-container]');
  
  if (!downloadContainer) return;

  if (downloadContainer.classList.contains('hide')) {
    button.innerHTML = 'Hide';
  } else {
    button.innerHTML = 'Show';
  }

  downloadContainer.classList.toggle('hide');
}

document.addEventListener('DOMContentLoaded', function() {
  var hideButton = document.querySelector('[data-hide]');

  if (!hideButton) return;

  hideButton.addEventListener('click', toggleDownloadSection);
});